<script lang="ts">
	import AssetsList from '#lib/AssetsList.svelte';
	import DocumentsList from '#lib/DocumentsList.svelte';
	import { t } from '#lib/i18n/tranlsator.svelte.ts';
	import Tab from '#lib/tabs/Tab.svelte';
	import TabNav from '#lib/tabs/TabNav.svelte';
	import TabNavItem from '#lib/tabs/TabNavItem.svelte';
	import Tabs from '#lib/tabs/Tabs.svelte';
	import { grow } from '#lib/util/transitions';
	import { getChatContext } from '#src/contexts/chat.context.svelte.ts';
	import { getDocumentContext } from '#src/contexts/documents.context.svelte.ts';
	import {
		getRightPanelContext,
		type RightPanelTab
	} from '#src/contexts/right-panel.context.svelte.ts';
	import IconClose from 'virtual:icons/material-symbols/right-panel-close-rounded';
	import IconAssets from 'virtual:icons/material-symbols/image-outline-rounded';
	import IconSources from 'virtual:icons/material-symbols/description-rounded';
	import { resizable } from './resizable.svelte';

	const rightPanelCtx = getRightPanelContext();
	const docCtx = getDocumentContext();
	const chatCtx = getChatContext();

	const sourcesCount = $derived(docCtx.documents.length + docCtx.secondarySources.length);

	function close() {
		rightPanelCtx.close();
		docCtx.clearSelection();
	}
</script>

{#if rightPanelCtx.isOpen}
	<div
		transition:grow={{ duration: 200, axis: 'x', reverse: true }}
		class="right-panel"
		{@attach resizable({
			side: 'left',
			minWidth: 200,
			maxWidth: 600,
			storageKey: 'layout.rightPanelWidth'
		})}
	>
		<div class="header">
			<TabNav
				activeTab={rightPanelCtx.activeTab}
				onchange={(id) => (rightPanelCtx.activeTab = id as RightPanelTab)}
			>
				<TabNavItem id="sources" badge={sourcesCount || undefined}>
					{#snippet icon()}<IconSources />{/snippet}
					{t('sources.header')}
				</TabNavItem>
				<TabNavItem id="assets" badge={chatCtx.assets.length || undefined}>
					{#snippet icon()}<IconAssets />{/snippet}
					{t('assets.header')}
				</TabNavItem>
			</TabNav>
			<button aria-label="Close panel" onclick={close} class="icon-button">
				<IconClose />
			</button>
		</div>
		<Tabs activeTab={rightPanelCtx.activeTab}>
			<Tab id="sources">
				<DocumentsList />
			</Tab>
			<Tab id="assets">
				<AssetsList />
			</Tab>
		</Tabs>
	</div>
{/if}

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;

	.right-panel {
		flex: 1 1 auto;
		overflow: hidden;
		background: var(--surface-1);
		@include lib.flex-column();
		z-index: 3;
		position: absolute;
		left: 0;
		top: 0;
		// because of resizable:
		min-width: 100%;
		max-width: 100%;

		max-height: 100%;
		border-bottom-left-radius: 1.5rem;
		border-bottom-right-radius: 1.5rem;
		border-bottom: 1px solid var(--border-subtle);

		@include lib.bp(gt-xs) {
			max-width: none;
			min-width: 0;
			flex: 0 0 auto;
			position: relative;
			width: 400px;
			border-bottom: none;
			border-radius: 0;
			border-left: 1px solid var(--border-subtle);
		}
	}

	.header {
		@include lib.flex-row();
		@include lib.flex-align(space-between);
		gap: 0.5rem;
		padding: 1rem;
		flex: 0 0 auto;
		button {
			@include lib.icon-button;
			margin: -0.5rem 0;
		}
	}
</style>
